// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5900": "9630fce8dadf","6563": "c118f70d3cdb","6962": "24f8eba02aa8","888": "8cf3ee70ad96","8990": "7d69c8cdd354",}[chunkId] + ".css"
}